var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPills(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.344 20L12.8 29.984a7.665 7.665 0 01-10.176.16c-2.88-2.528-3.424-6.752-1.44-9.92l.16-.224zm1.376-1.504c2.816-2.4 7.008-2.464 9.888.032 2.816 2.464 3.392 6.496 1.632 9.632l-.16.224-11.36-9.888zM12.672 0c1.472 0 2.912.512 4.064 1.44l.224.192 12.8 11.2A6.605 6.605 0 0132 17.344a6.704 6.704 0 01-1.6 4.768 6.605 6.605 0 01-4.928 2.24 6.519 6.519 0 01-4.096-1.44l-.224-.192-12.768-11.2c-2.72-2.368-3.008-6.528-.64-9.28A6.605 6.605 0 0112.672 0zm0 1.536c-1.44 0-2.848.608-3.776 1.728-1.792 2.016-1.632 5.088.288 6.944l.192.16 6.4 5.6 6.592-7.584-6.4-5.632a4.998 4.998 0 00-3.296-1.216z"
  })));
}

export default SvgPills;